// extracted by mini-css-extract-plugin
module.exports = {"light":"ThemeSelector_light__Ztp1v","night":"ThemeSelector_night__bmtcA","endemic":"ThemeSelector_endemic___NkLF"};